export const getLocationSearch = (): string => {
	if (typeof globalThis?.location?.search !== 'string') {
		return '';
	}

	return globalThis.location.search;
};
